module.exports = __webpack_public_path__ + "static/p3-9776b70324bc8918af303f3055bb3c86.png";